'use strict';

var MeshRendererController = require('./MeshRendererController'),
    MeshRendererDirective = require('./MeshRendererDirective');

angular.module('saturn.meshRenderer', [])
       .controller('MeshRendererController',[
         '$scope',
         '$element',
         '$templateCache',
         '$compile',
         '$sce',
         MeshRendererController
       ])
       .directive('sbMeshRenderer',[MeshRendererDirective]);

require('./templates.js');



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/meshRenderer/src/index.js